


































































import { Component, Ref, Vue } from 'vue-property-decorator';
import FormBookDemo from '@/components/forms/form-book-demo.vue';
import FormLogin from '@/components/forms/form-login.vue';
import FormLoginLimitedAccess from '@/components/forms/form-login-limited-access.vue';
import { RouterNames } from '@/util/enums/router-names';
import TheHeader from '@/components/headers/the-header.vue';

@Component({
  components: {
    FormBookDemo,
    FormLogin,
    FormLoginLimitedAccess,
    TheHeader,
  },
})
export default class TheLoginPrompt extends Vue {
  @Ref() bookDemoContainer: HTMLDivElement;
  
  windowSize = window.innerWidth;

  isProjectData: boolean = null;

  colClasses = 'col-12 col-md-10 col-lg-6'

  mounted() {
    window.addEventListener('resize', this.resizeHandler);
  }

  get bookDemoUrl() {
    return 'https://calendly.com/d/cqcv-4s7-cj8/projektagenten-demo'
      + '?hide_event_type_details=1'
      + '&hide_gdpr_banner=1'
      + '&primary_color=f45d01'
  }
  
  get isProject() {
    if (this.isProjectData == null) {
      this.isProjectData = this.$router.currentRoute.name === RouterNames.LOGGED_IN_PROJECT_VIEW;
      
      this.$router.afterEach((to, from) => {
        this.isProjectData = to.name === RouterNames.LOGGED_IN_PROJECT_VIEW 
      });
    }

    return this.isProjectData;
  }

  resizeHandler() {
    this.windowSize = window.innerWidth;
  }

  scrollToBookDemo() {
    if (this.bookDemoContainer) {
      this.bookDemoContainer.scrollIntoView();
    }
  }
}
